const WPConfig = {
  siteURL: "https://impedans.me/web/"
};
export default WPConfig;
